import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { UserTable } from '../components/users/UserTable';
import { UserModal } from '../components/users/UserModal';
import { SearchBar } from '../components/users/SearchBar';
import { Breadcrumb } from '../components/common/Breadcrumb';
const breadcrumbItems = [{
  label: 'Configuración',
  href: '#'
}, {
  label: 'Gestión de Usuarios'
}];
export const Users = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <div className="min-h-screen bg-gray-50" data-id="element-1532">
      <main className="pt-16 pl-64" data-id="element-1533">
        <div className="max-w-7xl mx-auto p-8" data-id="element-1534">
          <div className="mb-8" data-id="element-1535">
            <Breadcrumb items={breadcrumbItems} data-id="element-1536" />
            <div className="flex justify-between items-center mt-4" data-id="element-1537">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-1538">
                Gestión de Usuarios
              </h1>
              <button onClick={() => setIsModalOpen(true)} className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1539">
                <PlusIcon className="h-5 w-5 mr-2" data-id="element-1540" />
                Crear Nuevo Usuario
              </button>
            </div>
          </div>
          <SearchBar data-id="element-1541" />
          <UserTable data-id="element-1542" />
          <UserModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-1543" />
        </div>
      </main>
    </div>;
};